import { useIntl } from 'react-intl';

export const useHasIntlMessage = () => {
  const intl = useIntl();
  return (message: MessageId) => !!intl.messages[message];
};
